import { render, staticRenderFns } from "./AssociatedContractAdd.vue?vue&type=template&id=e65c5820"
import script from "./AssociatedContractAdd.vue?vue&type=script&lang=js"
export * from "./AssociatedContractAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports